import { render, staticRenderFns } from "./TrendingProductList.vue?vue&type=template&id=3a301500&"
import script from "./TrendingProductList.vue?vue&type=script&lang=js&"
export * from "./TrendingProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports